var _style;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      width: 64,
      height: 64,
      opacity: 1
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#4B4B4B;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M454.535,277.154c-35.431-35.465-84.645-57.483-138.744-57.465H95.8l116.068-103.851 c10.897-9.75,11.827-26.491,2.073-37.388c-9.754-10.905-26.49-11.827-37.391-2.078L8.828,226.43 c-0.177,0.156-0.298,0.362-0.47,0.517c-0.789,0.742-1.483,1.569-2.177,2.414c-0.453,0.535-0.939,1.044-1.341,1.621 c-0.65,0.914-1.168,1.922-1.697,2.923c-0.302,0.577-0.664,1.111-0.923,1.698c-0.526,1.208-0.888,2.483-1.233,3.776 c-0.117,0.449-0.31,0.862-0.406,1.319C0.207,242.465,0,244.292,0,246.171c0,1.88,0.207,3.707,0.582,5.465 c0.096,0.475,0.302,0.914,0.423,1.38c0.344,1.267,0.698,2.534,1.215,3.716c0.263,0.603,0.63,1.147,0.939,1.733 c0.526,0.991,1.039,1.983,1.681,2.896c0.397,0.569,0.88,1.069,1.323,1.603c0.703,0.845,1.41,1.69,2.212,2.44 c0.168,0.155,0.285,0.354,0.453,0.5L176.549,415.97c10.901,9.749,27.638,8.819,37.391-2.078 c9.754-10.896,8.824-27.638-2.073-37.388v-0.008L95.8,272.654h219.992c39.642,0.018,75.28,15.991,101.288,41.948 c25.956,26.007,41.938,61.654,41.956,101.291c0,14.62,11.853,26.482,26.482,26.482c14.62,0,26.482-11.862,26.482-26.482 C512.009,361.79,490,312.584,454.535,277.154z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.7bd27f99188ca40da4a2947f056983bf.svg";
export { ForwardRef as ReactComponent };